import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { EnterpriseService } from "../../enterprise.service";
import { Location } from "@angular/common";
import * as XLSX from "xlsx";

@Component({
  selector: "app-view-trips",
  templateUrl: "./view-trips.component.html",
  styleUrls: ["./view-trips.component.sass"],
})
export class ViewTripsComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private enterpriseService: EnterpriseService,
    private spinner: NgxSpinnerService,
    private toast: ToastrService,
    private location: Location,
  ) {}
  id: "";
  tripDetails: any;
  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.queryParams.id;
    this.getDetailsById();
  }

  getDetailsById() {
    this.spinner.show();
    this.enterpriseService.getTripByID(this.id).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.tripDetails = result.data;
        this.spinner.hide();
        console.log("trip details", this.tripDetails);
      } else {
        this.spinner.hide();
        this.toast.error(result.message);
      }
    });
  }

  statusMap: any = {
    1: "Pending",
    2: "Accepted",
    3: "Started",
    4: "Completed",
    5: "Cancelled",
  };
  stopStatus: any = {
    1: "Pending",
    2: "In-process",
    3: "Delivered",
    4: "Cancelled",
  };
  paymentStatus: any = {
    0: "Pending",
    1: "Success",
    2: "Partially Paid",
    3: "Failed",
  };

  goBack() {
    this.location.back();
  }

  exportSingleTripToExcel() {
    /* ---------------- Sheet 1: Trip Summary ---------------- */
    const trip = this.tripDetails;
    const tripSummary = [
      {
        "Trip Code": trip.tripCode,
        Status: this.statusMap[trip.status] || "Unknown",
        "Total Distance (KM)": trip.totalDistance,
        "Total Duration (Min)": trip?.estimatedCost?.data?.totalDuration || "",
        "Vehicle Type": trip?.vehicleDetails?.type || "",
        "Trip Fare": trip?.estimatedCost?.data?.discountedTripFare || "",
        "Driver Amount": trip.driverReceivingAmount,
        "Enterprise Email": trip?.enterpriseDetails?.email || "",
        "Enterprise Phone": trip?.enterpriseDetails?.phone || "",
        "Created At": new Date(trip.createdAt).toLocaleString(),
      },
    ];

    /* ---------------- Sheet 2: Stops ---------------- */

    const stopsData = trip.stops.map((stop: any, index: number) => ({
      "Stop No": index,
      "Stop Name": stop.name,
      Address: stop.address,
      "Contact Name": stop.contactName,
      "Contact Phone": stop.contactPhone,
      "Amount Collected": stop.amount,
      "Payment Mode": stop.paymentMode || "",
      "Delivered At": stop.deliveredAt
        ? new Date(stop.deliveredAt).toLocaleString()
        : "",
    }));

    /* ---------------- Sheet 3: Payment ---------------- */

    const payment = trip.paymentDetails;

    const paymentData = [
      {
        "Trip Code": payment.tripCode,
        "Payment Status": this.paymentStatus[payment.paymentStatus] || "",
        "Payment Method": payment.paymentMethod,
        "Total Amount": payment.billDetails.totalAmount,
        "Net Fare": payment.billDetails.netFare,
        "Coupon Discount": payment.billDetails.couponDiscount,
      },
    ];

    /* ---------------- Create Workbook ---------------- */

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.json_to_sheet(tripSummary),
      "Trip Summary",
    );

    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.json_to_sheet(stopsData),
      "Stops",
    );

    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.json_to_sheet(paymentData),
      "Payment",
    );

    XLSX.writeFile(workbook, `Trip_${trip.tripCode}.xlsx`);
  }
}
